<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.subscribers") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="1000000000000000"
        hide-default-footer
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.user">-</h6>
            <p v-else>
              {{ item.user.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.mobile`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.user">-</h6>
            <p v-else>
              {{ item.user.mobile }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.price_without_vat`]="{ item }">
          <div class="table_image_wrapper">
            <p>
              {{ calculatePriceWithoutVat(item) }}
              {{ $t("PLACEHOLDERS.currency") || "ريال" }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.vat`]="{ item }">
          <div class="table_image_wrapper">
            <p>
              {{ item.vat || "0.00" }}
              {{ $t("PLACEHOLDERS.currency") || "ريال" }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.total_price`]="{ item }">
          <div class="table_image_wrapper">
            <p>
              {{ item.price || "0.00" }}
              {{ $t("PLACEHOLDERS.currency") || "ريال" }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.subscription_period`]="{ item }">
          <div class="table_image_wrapper">
            <p v-if="item.from && item.to">
              {{ formatDate(item.from) }} - {{ formatDate(item.to) }}
            </p>
            <p v-else>-</p>
          </div>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <div class="table_image_wrapper">
            <span
              :class="{
                'text-success': item.status === 'working',
                'text-warning': item.status === 'pending',
                'text-danger': item.status === 'expired',
              }"
            >
              {{ getStatusText(item.status) }}
            </span>
          </div>
        </template>

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("PLACEHOLDERS.user_balance") }}</span>
              </template>
              <button class="btn_show" @click="showUserBalance(item)">
                <i class="fal fa-wallet"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
        <!-- <template v-slot:[`item.id`]="{ index }">
          {{
            (paginations.current_page - 1) * paginations.items_per_page +
            index +
            1
          }}
        </template> -->
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Image Modal -->
          <image-modal
            v-if="dialogImage"
            :modalIsOpen="dialogImage"
            :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage"
          />
          <!-- End:: Image Modal -->

          <!-- Start:: Description Modal -->

          <description-modal
            v-if="dialogDescription"
            :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow"
            @toggleModal="dialogDescription = !dialogDescription"
          />
          <!-- End:: Description Modal -->

          <!-- Start:: Delete Modal -->
          <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>
              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmDeleteItem">{{
                  $t("BUTTONS.ok")
                }}</v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Delete Modal -->

          <!-- Start:: User Balance Modal -->
          <v-dialog v-model="dialogUserBalance" max-width="600px">
            <v-card>
              <v-card-title
                class="text-h5 justify-center"
                :class="$vuetify.theme.dark ? 'white--text' : ''"
              >
                {{ $t("PLACEHOLDERS.user_balance") }}
                <span v-if="selectedUser">
                  - {{ selectedUser.user?.name }}</span
                >
              </v-card-title>
              <v-card-text>
                <div class="user-balance-content" v-if="selectedUser">
                  <div class="balance-info mb-4">
                    <v-row>
                      <v-col cols="6">
                        <div
                          class="info-card text-center p-3"
                          style="background: #e8f5e8; border-radius: 8px"
                        >
                          <h3 class="success--text">
                            {{ selectedUser.remaining_ads || 0 }}
                          </h3>
                          <p class="mb-0" style="color: #2e7d32">
                            {{ $t("PLACEHOLDERS.remaining_ads") }}
                          </p>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div
                          class="info-card text-center p-3"
                          style="background: #ffe8e8; border-radius: 8px"
                        >
                          <h3 class="error--text">
                            {{ selectedUser.used_ads || 0 }}
                          </h3>
                          <p class="mb-0" style="color: #c62828">
                            {{ $t("PLACEHOLDERS.used_ads") }}
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="total-ads mb-3">
                    <div
                      class="info-card text-center p-3"
                      style="background: #f0f8ff; border-radius: 8px"
                    >
                      <h3 class="primary--text">
                        {{ selectedUser.total_ads || 0 }}
                      </h3>
                      <p class="mb-0" style="color: #1976d2">
                        {{ $t("PLACEHOLDERS.total_ads") }}
                      </p>
                    </div>
                  </div>

                
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="modal_cancel_btn"
                  @click="dialogUserBalance = false"
                >
                  {{ $t("BUTTONS.close") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: User Balance Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <!-- <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template> -->
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Allpackages",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        is_active: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.name"),
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.mobile"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.price_without_vat"),
          value: "price_without_vat",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.vat_amount"),
          value: "vat",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_price_with_vat"),
          value: "total_price",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.subscription_period"),
          value: "subscription_period",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },

        // {
        //   text: this.$t("TABLES.Admins.actions"),
        //   value: "actions",
        //   sortable: false,
        //   align: "center",
        // },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      dialogUserBalance: false,
      selectedUser: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 1000000000,
      },
      // End:: Pagination Data

      regions: [],
      cites: [],
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Helper methods for data formatting
    calculatePriceWithoutVat(item) {
      if (!item.price || !item.vat) return "0.00";
      const totalPrice = parseFloat(item.price);
      const vatAmount = parseFloat(item.vat);
      const priceWithoutVat = totalPrice - vatAmount;
      return priceWithoutVat.toFixed(2);
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    getStatusText(status) {
      const statusMap = {
        working: this.$t("STATUS.active") || "نشط",
        pending: this.$t("STATUS.pending") || "معلق",
        expired: this.$t("STATUS.expired") || "منتهي الصلاحية",
      };
      return statusMap[status] || status;
    },

    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/packages/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    async resetFilter() {
      // this.filterOptions.name = null;
      // this.filterOptions.is_active = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/packages/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get packages
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      console.log(`packages/subscribers`);
      try {
        const params = {
          page: this.paginations.current_page,
        };
        let res = await this.$axios({
          method: "GET",
          url: `packages/subscribers/${this.$route.params?.id}`,
          params: params,
        });

        this.loading = false;
        this.tableRows = res.data.data.subscribers;
        this.paginations.last_page = res.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data);
      }
    },
    // End:: Set Table Rows
    showReplayModal(replay) {
      this.dialogDescription = true;
      this.selectedDescriptionTextToShow = replay;
    },

    // Start:: Control Modals
    showImageModal(image) {
      this.dialogImage = true;
      this.selectedItemImage = image;
    },

    showUserBalance(item) {
      this.selectedUser = item;
      this.dialogUserBalance = true;
    },
    // End:: Control Modals
  },

  created() {
    // Start:: Fire Methods
    this.setTableRows();
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    // End:: Fire Methods
  },
};
</script>
